import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import ExpenseCategoryService from "../../../services/expenses/expenseCategoryServices";

const EditExpenseCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // ✅ Get ID from URL

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [category_name, setCategory_name] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);

  // ✅ Load existing category
  useEffect(() => {
    if (!id) return;

    ExpenseCategoryService.getCategory(id)
      .then((res) => {
        const name = res?.data?.category_name || "";
        setCategory_name(name);
        reset({ categoryname: name });
      })
      .catch(() => {
        toast.error("Failed to load category");
      });
  }, [id, reset]);

  const handleCancel = () => {
    navigate("/expense-categories");
  };

  // ✅ Save / Update
  const handleRegister = () => {
    setLoading(true);
    setDisable(true);

    const payload = {
      category_name: category_name,
    };

    ExpenseCategoryService.updateCategory(id, payload)
      .then(() => {
        toast.success("Expense Category Updated");
        setTimeout(() => navigate("/expense-categories"), 1500);
      })
      .catch(() => {
        toast.error("Update Failed");
        setLoading(false);
        setDisable(false);
      });
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />

      <div className="content container-fluid">
        <h5>{t("Edit Expense Category")}</h5>

        <h6>
          <Link to="/expense-categories" className="tc">
            {t("Expense Categories")}
          </Link>{" "}
          / <span>{t("Edit Category")}</span>
        </h6>

        <form onSubmit={handleSubmit(handleRegister)}>
          <div className="form-group">
            <label>{t("Category Name")}</label>

            <input
              type="text"
              className="form-control"
              value={category_name}
              {...register("categoryname", {
                onChange: (e) => setCategory_name(e.target.value),
                required: true,
              })}
            />

            {errors.categoryname && (
              <div className="invalid-feedback d-block">
                Category Name is required
              </div>
            )}
          </div>

          <div className="text-left py-3">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-secondary"
            >
              {t("Cancel")}
            </button>

            &nbsp;&nbsp;

            <button
              type="submit"
              className="btn btn-primary"
              disabled={disable}
            >
              {loading ? <ButtonLoading /> : t("Save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditExpenseCategory;
